<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Продукт
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="text" name="title" [(ngModel)]="model.title" class="form-control" required
                    placeholder="Заголовок">
                  <label>Заголовок</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-check form-switch mb-3">
                  <input class="form-check-input" type="checkbox" name="isPublished" [(ngModel)]="model.isPublished">
                  <label class="form-check-label" for="flexSwitchCheckDefault">Опубликована</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input class="form-control" readonly name="startDateUtc" [(ngModel)]="selectedStartDate" ngbDatepicker
                    #dStart="ngbDatepicker" (click)="dStart.toggle()" />
                  <label>Дата начала</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <ngb-timepicker name="startTime" class="no-show-btn" [(ngModel)]="selectedStartTime"></ngb-timepicker>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input class="form-control" readonly name="endDateUtc" [(ngModel)]="selectedEndDate" ngbDatepicker
                    #dEnd="ngbDatepicker" (click)="dEnd.toggle()" />
                  <label>Закончить</label>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <ngb-timepicker name="endTime" class="no-show-btn" [(ngModel)]="selectedEndTime"></ngb-timepicker>
                </div>
              </div>
            </div>

            <div class="col-12 mb-4">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <textarea [(ngModel)]="model.content" name="content" placeholder="Текст" rows="5"
                    class="form-control"></textarea>
                  <label>
                    Текст
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex">
                @for (image of model.images; track image) {
                <div class="image mb-2 me-2">
                  <img [src]="image.path" [title]="image.originalName" />
                  <div class="overflow">
                    <div class="remove" (click)="removeImage(image)">
                      <i class="fa-solid fa-times"></i>
                    </div>
                  </div>
                </div>
                }
              </div>
              <label class="w-100">
                Новое изображение
                <input type="file" (change)="selectFile($event)" class="form-control" accept="image/*" />
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
    @if (isBusy) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
    }

  </div>
</app-wrapper>